import Choices from 'choices.js';

export default(() => {
    const memberTypeSelector = document.querySelector('.member-type-selector');
    const hasSelectedClass = 'member-type-selector--selected';
    const selectedClass = 'member-type-selector__item-button--selected';

    let selectedItem;
    let selectedOptions;
    let toggleClasses;
    let updateType;

    if (memberTypeSelector) {
        const memberTypesButtons = Array.from(document.querySelectorAll('.member-type-selector__item-button'));
        const memberTypeDropdownSelect = document.querySelector('#memberTypeSelect');
        const memberTypes = JSON.parse(memberTypeDropdownSelect.getAttribute('data-memberMap'));
        const carousel = document.querySelector('.member-options-carousel__carousel');
        const selectChoices = [
            { value: '', label: 'We work in large-scale energy' },
            { value: '', label: 'We work excl. in small-scale energy' },
            { value: '', label: 'We work in professional services' },
            { value: '', label: 'I’m an individual consultant' },
        ];

        memberTypesButtons.forEach((btn, index) => {
            btn.setAttribute('value', memberTypes[index].value);
            btn.setAttribute('member-options', memberTypes[index].options);
        });

        memberTypesButtons.forEach(btn => btn.addEventListener('click', (e) => {
            memberTypeSelector.classList.add(hasSelectedClass);
            toggleClasses(btn);
            e.preventDefault();
        }));

        const mapSelectCoices = () => {
            memberTypes.forEach((option, index) => {
                const values = option.options.join(',');
                if (values.length && values !== ',') {
                    selectChoices[index].value = values;
                } else {
                    selectChoices.splice(index, index);
                }

            });
        };

        mapSelectCoices();

        const memberTypeDropdown = new Choices(memberTypeDropdownSelect, {
            searchEnabled: false,
            placeholder: true,
            placeholderValue: 'Select One',
            itemSelectText: '',
            choices: selectChoices,
        });

        memberTypeDropdownSelect.addEventListener('change', (e) => {
            updateType(e);
        });

        toggleClasses = (btn) => {
            selectedItem = document.querySelector('.member-type-selector__item-button--selected');
            selectedOptions = btn.getAttribute('member-options');
            memberTypeDropdown.setChoiceByValue(selectedOptions);

            if (selectedItem) selectedItem.classList.toggle(selectedClass);
            btn.classList.toggle(selectedClass);
            carousel.dataset.selectedOptions = selectedOptions;
        };

        const setButtonClass = (options) => {
            selectedItem = document.querySelector('.member-type-selector__item-button--selected');
            const button = document.querySelectorAll(`[member-options='${options}']`);

            if (selectedItem) selectedItem.classList.toggle(selectedClass);
            button[0].classList.toggle(selectedClass);
        };

        updateType = (e) => {
            setButtonClass(e.detail.value);
            carousel.dataset.selectedOptions = e.detail.value;
        };
    }
})();
